export function inferHospitalKind(name?: string | null): string {
  const value = String(name || "").toLowerCase();
  if (!value) return "Hospital";
  if (/\bmps\b|multipurpose/.test(value)) return "Multipurpose service";
  if (/community/.test(value)) return "Community hospital";
  if (/base/.test(value)) return "Base hospital";
  if (/district/.test(value)) return "District hospital";
  if (/referral|tertiary/.test(value)) return "Referral hospital";
  if (/general/.test(value)) return "Referral hospital";
  if (/health service|healthservice/.test(value)) return "Health service";
  return "Hospital";
}

export function formatFillRate(value: unknown, openShifts?: number): string {
  if (value == null || value === "") return "—";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "—";
  // Quiet book (nothing open): all-time 100% vs "no history" dash is noise.
  if (openShifts != null && openShifts <= 0) return "—";
  return `${numeric % 1 === 0 ? numeric.toFixed(0) : numeric.toFixed(1)}%`;
}
